import { render, staticRenderFns } from "./TaxpayerData.vue?vue&type=template&id=1d967f23"
import script from "./TaxpayerData.vue?vue&type=script&lang=js"
export * from "./TaxpayerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports